import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';

const ENDORSEMENT_ICONS = {
    'Friendly': 'proposal/badge_friendly.svg',
    'Knowledgeable': 'proposal/badge_knowledgeable.svg',
    'Responsive': 'proposal/badge_responsive.svg',
    'Honest': 'proposal/badge_honest.svg',
    'Well Connected': 'proposal/badge_connected.svg',
    'Good Negotiator': 'proposal/badge_negotiator.svg',
    'Tech Savvy': 'proposal/badge_tech.svg'
};
export default class SuggestedAgents extends Component {
    state = {
        messagedAgents: {},
        invitedAgents: {}
    }

    static get propTypes() {
        return {
            requestId: PropTypes.number,
            isBuyer: PropTypes.bool,
            realtors: PropTypes.array,
            quotes: PropTypes.array,
            endorsements: PropTypes.array
        };
    }

    inviteAgent(realtor) {
        const {requestId, isBuyer} = this.props;

        return $.post(isBuyer ? 'buyerInviteAgent-json' : 'sellerInviteAgent-json', {
            requestId,
            realtorId: realtor.realtorId
        }, data => {
            if (checkAjax(data)) {
                this.setState({
                    invitedAgents: {
                        ...this.state.invitedAgents,
                        [realtor.realtorId]: true
                    }
                });
            }
        });
    }

    inviteAndMessageAgent(quote, realtor) {
        const {isBuyer} = this.props;
        const clientType = isBuyer ? 'buyer' : 'seller';
        const proposalType = isBuyer ? 'Buyer proposal' : 'Seller proposal';

        this.inviteAgent(realtor).always(data => {
            data.msg && defaultAjaxError(data.msg);
            const quoteId = (quote ? quote.responseId : null) || data.responseId;

            if (quoteId) {
                showSendMessageDialog({
                    quoteId: quoteId,
                    seller: !isBuyer,
                    agentName: realtor.name,
                    agentPhotoUrl: realtor.filteredPhoto,
                    hideContactStep: true,
                    disablePageReload: true,
                    afterMessageSent: () => {
                        this.setState({
                            messagedAgents: {
                                ...this.state.messagedAgents,
                                [realtor.realtorId]: true
                            }
                        });
                    }
                });
                ga('send', 'event', 'Quote', clientType + 'ClickInfo', 'User clicked info to quote');

                mixpanel.track(clientType + 'ClickInfo', {quoteId: quoteId});
                mixpanel.people.set({lastEvent: clientType + 'ClickInfo', userType: userType,
                    has_voice_greeting: quote && !!quote.voiceUrl,
                    has_featured_video: quote && !!quote.realtor.featured_video,
                    realtor_id: quote && quote.realtor.realtorId,
                    proposal_id: quoteId
                });
                window.optimizely.push(["trackEvent", clientType + "ClickInfo"]);

                trackEvent('Proposal', 'messageAgent', 'messageAgent', {
                    proposal_type: proposalType,
                    realtor_id: realtor.realtorId,
                    proposal_id: quoteId
                }).withGA();
            }
        });
    }

    renderAgent(realtor, quote, endorsement) {
        const {messagedAgents, invitedAgents} = this.state;

        return (
            <div className="pt-3x pb-3x pt-4x-sm pb-4x-sm agent">
                <div className="row">
                    <div className="col-xs-12 col-sm-6">
                        <div className="agent-info clearfix">
                            <div className="agent-photo avatar">
                                <img src={realtor.filteredPhoto} alt="agent avatar"/>
                            </div>
                            <div className="buttons pl-2x pl-3x-sm">
                                <div className="mb-2x-sm agent-name">
                                    {realtor.name}
                                </div>
                                {(quote && quote.needInfoDate != null || !!messagedAgents[realtor.realtorId])
                                    ?
                                    <button
                                        type="button"
                                        className="btn btn-default message messaged"
                                        disabled>
                                        Messaged
                                    </button>
                                    : [
                                        <button
                                            key="message"
                                            type="button"
                                            className="btn btn-default message"
                                            onClick={() => this.inviteAndMessageAgent(quote, realtor)}>
                                            Message
                                        </button>,
                                        <button
                                            key="messaged"
                                            type="button"
                                            className="btn btn-default message messaged"
                                            disabled
                                            style="display: none">
                                            Messaged
                                        </button>
                                    ]
                                }
                                {(quote && quote.userInvite != null || !!invitedAgents[realtor.realtorId])
                                    ?
                                    <button
                                        type="button"
                                        className="btn btn-gray-light invited"
                                        disabled>
                                        Invited
                                    </button>
                                    : [
                                        <button
                                            key="invite"
                                            type="button"
                                            className="btn btn-default invite"
                                            onClick={() => this.inviteAgent(realtor)}>
                                            Invite
                                        </button>,
                                        <button
                                            key="invited"
                                            type="button"
                                            className="btn btn-gray-light invited"
                                            style="display: none"
                                            disabled>
                                            Invited
                                        </button>
                                    ]
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <div className="agent-stats">
                            <div className="stats-item">
                                <img className="stats-icon mr-1x mr-2x-sm" src={global.imageBaseUrl + 'proposal/badge_experience.svg'}/>
                                <div className="stats-value">
                                    {realtor.yearsOfExp} Years of Experience
                                </div>
                            </div>
                            <div className="stats-item">
                                <img className="stats-icon mr-1x mr-2x-sm" src={global.imageBaseUrl + 'proposal/badge_sales.svg'}/>
                                <div className="stats-value">
                                    {realtor.pastTwelveMonthsTx} Sales in Your Area
                                </div>
                            </div>
                            {endorsement ? (
                                <div className="stats-item">
                                    <img className="stats-icon mr-1x mr-2x-sm" src={global.imageBaseUrl + ENDORSEMENT_ICONS[endorsement]}/>
                                    <div className="stats-value">
                                        {endorsement}
                                    </div>
                                </div>
                            ) : (
                                <div className="stats-item">
                                    <img className="stats-icon mr-1x mr-2x-sm" src={global.imageBaseUrl + 'proposal/badge_price_range.svg'}/>
                                    <div className="stats-value">
                                        Specialized in {realtor.priceRangeStr}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="suggested-agents">
                {this.props.realtors.map(realtor => {
                    return this.renderAgent(
                        realtor,
                        this.props.quotes[realtor.realtorId],
                        this.props.endorsements[realtor.realtorId]);
                })}
            </div>
        );
    }
}
